import { render } from "./ChangePriceModal.vue?vue&type=template&id=bb3b4ea8&ts=true"
import script from "./ChangePriceModal.vue?vue&type=script&lang=ts"
export * from "./ChangePriceModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__